module.exports = __webpack_public_path__ + "static/img/nomaan-2.a02087e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/nomaan-2.png
// module id = eiXM
// module chunks = 1